import { CampaignProps, CopywritingShoppableImage } from '@commons/types'
import Content from '@components/media-text/components/content/Content'
import { Product as ProductSku } from '@components/media-text/components/content/types'
import Heading from '@components/media-text/components/heading/Heading'
import ShopTheLook from '@components/media-text/components/shopTheLook/ShopTheLook'
import Visual from '@components/media-text/components/visual/Visual'
import stylesMediaText from '@components/media-text/MediaText.module.scss'
import { usePbProps } from '@content/helpers/src/context'
import { useProducts } from '@content/helpers/src/contextProducts'
import { makeId } from '@content/helpers/src/utils.ts'
import CTA from '@commons/cta/CTA.tsx'

import {
    getProduct,
    ProductTypeDTO,
    viewItemList
} from '@nespresso/catalog-sdk'
import { Modal } from '@nespresso-design-system/components'
import { useEffect, useState } from 'preact/hooks'
import styles from './ShoppableImage.module.scss'

export default function PlaceholderShoppableImage({ onOpenModal }) {
    const {
        copywriting,
        campaign
    }: { copywriting: CopywritingShoppableImage; campaign: CampaignProps } =
        usePbProps()

    const {
        link,
        title,
        description,
        image,
        cta,
        cta_secondary,
        modal,
        products,
        promotion_details
    } = copywriting

    const [isOpen, setIsOpen] = useState(false)
    const modalVideoId = `modal-${makeId(4)}`
    const { setProducts } = useProducts()

    const openModal = () => {
        setIsOpen(true)

        const SKUs = products.map((product: ProductSku) => product)

        viewItemList(SKUs, {
            listId: campaign.position,
            listName: `${campaign.position} - ${modal?.heading}`,
            eventRaisedBy: campaign.position
        })
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    async function getAllProducts(productIds: ProductSku[]) {
        const productRequests = productIds.map(p =>
            getProduct<ProductTypeDTO.Capsule>(p?.sku)
        )

        const productData = await Promise.all(productRequests)
        setProducts(productData as any)
    }

    useEffect(() => {
        getAllProducts(products)
    }, [products])

    return (
        <>
            <div className={stylesMediaText['media-text__placeholder']}>
                <div
                    className={`${stylesMediaText['placeholder-shoppable-image']} ${styles['placeholder-shoppable-image']}`}>
                    <Visual
                        alt_text={image?.desktop?.alt}
                        desktop={image?.desktop?.src}
                        mobile={image?.mobile?.src}
                        retina={image?.retina?.src}></Visual>

                    <Modal
                        heading={modal?.heading}
                        description={modal?.description}
                        closeBtnA11yLabel={
                            modal?.translations?.closeBtnA11yLabel
                        }
                        id={modalVideoId}
                        position="side"
                        isOpen={isOpen}
                        onClose={closeModal}
                        // footerSlot={<Button {...shoppableImageDetails.modal.addAllToBasket} onClick={addAllToBasket} />}
                        contentSlot={
                            <ShopTheLook disableTracking={true}></ShopTheLook>
                        }
                    />

                    <div className={styles['placeholder-shoppable-image__cta']}>
                        <CTA
                            {...modal?.cta_products_secondary}
                            onClick={openModal}
                        />
                    </div>
                </div>
            </div>
            <div className={stylesMediaText['media-text__content']}>
                <div>
                    <Heading title={title} />
                </div>
                <div>
                    <Content
                        link={link}
                        onOpenModal={onOpenModal}
                        promotion_details={promotion_details}
                        campaign={campaign}
                        text={description}
                        buttonPrimary={cta}
                        buttonSecondary={cta_secondary}
                    />
                </div>
            </div>
        </>
    )
}
